import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { ApplicationAgentIntegration } from 'yeself-common/typings/application/Application';

import CheckboxField from './CheckboxField';

type AgentIntegrationFormProps = {
    onChange: (value: ApplicationAgentIntegration) => void;
    value: ApplicationAgentIntegration;
};

const AgentIntegrationForm = ({ value, onChange }: AgentIntegrationFormProps): React.ReactElement => {
    const handleOnChange = useCallback(
        <T extends keyof ApplicationAgentIntegration>(name: T) =>
            (newValue: ApplicationAgentIntegration[T]) => {
                onChange({
                    ...value,
                    [name]: newValue,
                });
            },
        [onChange, value]
    );

    return (
        <Grid container>
            <Grid item>
                <FormControlLabel
                    control={
                        <CheckboxField
                            color="primary"
                            value={value.popups}
                            onChange={handleOnChange('popups')}
                            disabled={value.startFromIFrame}
                        />
                    }
                    label={<FormattedMessage id="Settings.integration.checkBox.popups" />}
                />
            </Grid>
            <Grid item>
                <FormControlLabel
                    control={
                        <CheckboxField
                            color="primary"
                            value={value.startFromIFrame}
                            onChange={handleOnChange('startFromIFrame')}
                            disabled={value.popups}
                        />
                    }
                    label={<FormattedMessage id="Settings.integration.checkBox.startFromIFrame" />}
                />
            </Grid>
            <Grid item>
                <FormControlLabel
                    control={
                        <CheckboxField
                            color="primary"
                            value={value.enableEditorRedirect}
                            onChange={handleOnChange('enableEditorRedirect')}
                        />
                    }
                    label={<FormattedMessage id="Settings.integration.checkBox.enableEditorRedirect" />}
                />
            </Grid>
        </Grid>
    );
};

export default AgentIntegrationForm;
